"use client";

import { useState } from "react";
import { subscribe } from "@/lib/subscribe";

export default function Subscribes() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await subscribe(email);
    } catch (error) {
      console.error("Error:", error.message);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="bg-white mt-8 flex px-1 py-1.5 rounded-full shadow-[0_5px_22px_-8px_rgba(93,96,127,0.2)] sm:w-4/5 overflow-hidden"
    >
      <input
        name="email"
        value={email}
        type="email"
        onChange={handleEmailChange}
        required
        placeholder="Enter your email"
        className="w-full font-bold outline-none bg-white pl-4 text-sm"
      />
      <button
        type="submit"
        className="bg-custom-blue hover:bg-custom-blue transition-all text-white font-bold text-sm rounded-full px-4 py-2.5"
      >
        Subscribe
      </button>
    </form>
  );
}
